module.exports = __webpack_public_path__ + "img/6-2_Causal_Graph.cda6fe4c.png";